import React, { useState, useCallback, } from 'react';
import Popper, { PopperProps, } from '@material-ui/core/Popper';

import { utils, } from 'styles';

type Props = Partial<PopperProps> & {
    children: any,
    renderContent: any,
};

const genericStyles = {
    zIndex: 1430,
};

const ShoppingCartPopper: React.FC<Props> = ({
    renderContent,
    children,
    ...props
}) => {
    const [ anchorEl, setAnchorEl ] = useState<HTMLButtonElement | null>(null);
    const [ open, setOpen ] = useState(false);
    const popperClass = utils.makeGenericStyles(genericStyles);

    const handleOpenStatus = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setOpen(prevState => !prevState);
    }, [ setAnchorEl, setOpen, ]);

    return (
        <>
            {children({ handleOpenStatus, })}
            <Popper open={open}
                    className={popperClass.root}
                    anchorEl={anchorEl}
                    {...props}>
                {(popperProps) => renderContent({ ...popperProps, open, setOpen, })}
            </Popper>
        </>
    );
};

ShoppingCartPopper.defaultProps = {
    placement: 'bottom-end',
    transition: true,
};

export default ShoppingCartPopper;
